import { IssueStatus, issues, monitors, me } from "../fixtures";

const wait = async (timeout = 400) => {
  await new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

export const getMyOpenIssueCount = async () => {
  await wait();
  return {
    open: issues.filter(
      (issue) =>
        ![IssueStatus.Resolved, IssueStatus.Muted].includes(issue.status) &&
        issue.assignee?.id === me.id,
    ).length,
  };
};

export const getAllOpenIssueCount = async () => {
  await wait();
  return {
    open: issues.filter(
      (issue) =>
        ![IssueStatus.Resolved, IssueStatus.Muted].includes(issue.status),
    ).length,
  };
};

export const getAllMonitors = async () => {
  await wait();
  return { monitors: monitors.filter((monitor) => !monitor._deleted) };
};
